/**************************************************
 * Nombre:       Tarjeta_Proceso_Adminision
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import {theme} from "../../Tema";


const Tarjeta_Proceso_Adminision = ({item, index}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 1.5}} sx={{justifyContent: 'flex-start'}}>
                <IconButton sx={{
                    backgroundColor: theme.palette.primary.main,
                    border: 2,
                    width: 48,
                    height: 48,
                    borderColor: theme.palette.secondary.main,
                }}>
                    <Typography sx={{color: '#fff', fontWeight: 600}}>{index + 1}</Typography>
                </IconButton>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 10}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{
                        fontWeight: 800, color: theme.palette.primary.main, fontSize: 18
                    }}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{
                        fontWeight: 300, fontSize: 18
                    }}>{item.descripcion}</Typography>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Proceso_Adminision